import { useMutation } from 'react-query'
import { getErrorTranslationKey } from 'src/helpers/getApiErrorTranslationKey'
import { requestReturningPatientOtpCode, VerifyPhoneResponse } from 'src/services/api/verifyPhone'
import { addVerifyInfo, useVerifyPhoneDispatch } from '@context/VerifyPhoneContext'

interface RequestReturningPatientOtpCode {
  onSuccess?: (data: VerifyPhoneResponse) => void
  onError: (errorTranslationKey: string) => void
}

export const useRequestReturningPatientOtpCode = ({ onSuccess, onError }: RequestReturningPatientOtpCode) => {
  const verifyPhoneDispatch = useVerifyPhoneDispatch()

  return useMutation(requestReturningPatientOtpCode, {
    onSuccess: (data) => {
      verifyPhoneDispatch(addVerifyInfo(data.phone || '', data.validity))
      onSuccess?.(data)
    },
    onError: (error: any) => {
      onError(getErrorTranslationKey(error))
    },
  })
}
